module.exports = __webpack_public_path__ + "static/campus-e2e5b0a31d8e5880602b7735bb9d54b8.jpg";